import { OrderState } from "../../../cubiq-model-multi-asset/model/enum/OrderState";
import { OrderTransferRecordState } from "./OrderTransferRecordState";

export class OrderTransferRecord<T = any> {
  constructor(
    public transferId: string = "",
    public orderId: string = "",
    public rootOrderId: string = "",
    public orderRef: string = "",
    public orderDescription: string = "",
    public traderGroupName: string = "",
    public orderStatus: string = "",
    public strategyId: string = null,
    public reason: string = "",
    public external: boolean = false,
    public transferIdIsRisk: boolean = false,
    public transferIdIsSpawned: boolean = false,
    public state: OrderTransferRecordState = OrderTransferRecordState.IN_PROGRESS,
    public rawData: null | T = null,
    public orderState: OrderState = null,
  ) {}
}
